import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { ViewProfileService } from 'src/app/shared/services/view-profile-servies/view-profile.service';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.css'],
})
export class NotificationSettingsComponent {
  // customerNotificationForm: FormGroup =new

  sms: boolean = false;
  email: boolean = false;
  customerId:any;
  constructor(
    private formBuilder: FormBuilder,
    private profileService: ViewProfileService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly customerService: CustomerService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      // Access the 'id' parameter from the URL
      this.customerId= params['id'];
      console.log('ID from URL:',this.customerId);
      // Now you can use this 'id' in your component logic
    });
    if(this.customerId){
      this.getCustomerDetail(this.customerId)
    }else{
    this.profileService.getProfile().subscribe((data: any) => {
      this.email = data.data.config.notifyConfig.emailNotify;
      this.sms = data.data.config.notifyConfig.smsNotify;
    });
  }}
  getCustomerDetail(id:any){
    this.customerService.getCustomerDetails(id).subscribe( data => {
      this.email = data.data.notifyConfig.emailNotify;
      this.sms = data.data.notifyConfig.smsNotify;
    });
  }
}
